export default __webpack_public_path__ + "media/images/features/local_delivery/sanada-san-ccaec016ba9c8dfa956eed73ef991828.jpg";